import {useNavigate} from "react-router-dom";
import { Exit , Home , Call , Logout as LogoutIcon , Feedback , MedicalHistory , BookAppointment , Sun , Moon, Login , Lang, Heart} from "../../../Assets/SVGS";
import "./MobileNavMenu.css";
import userImage from "../../../Assets/Images/doctor.jpeg";
import { useState } from "react";
import { motion  , AnimatePresence} from "framer-motion";
import darkModeSlice from "../../../zustand/DarkModeSlice";
import Logout from "../../../utils/logout";
import BtnLoader from "../BtnLoader/BtnLoader";
import { useTranslation } from 'react-i18next';

function MobileNavMenu({isNavMobileMenuOpen, navMobileMenuFunc}) {
  const [loader , setLoader] = useState(false)
  const userData = JSON.parse(localStorage.getItem("userData")) || null
  const {theme , changeMode} = darkModeSlice()
  const nav = useNavigate();
  const { t, i18n } = useTranslation();
  const [isLogoutModalOpen , setIsLogoutModalOpen] = useState(false)
  return (
    <>
    <div
      className={isNavMobileMenuOpen ? "menu-backdrop show" : "menu-backdrop"}
      onClick={() => navMobileMenuFunc()}
    />
    <div className={isNavMobileMenuOpen ? "menu show" : "menu"}>
      <div className='menu-header'>
        {/* <Logo /> */}
        <div className="userData">
          <img src={userData?.img?userData.img:userImage} loading="lazy" alt="userimage"/>
          <div>
            <h3>{userData?(userData.first_name +" " + userData.last_name):t('userName')}</h3>
            <p>{userData?userData?.role:t('user')}</p>
          </div>
        </div>
        <div className='icon close' onClick={() => navMobileMenuFunc()}>
          <Exit width='40px' />
        </div>
      </div>
      <div className='mobileMenu-links'>
        <a href='/'>
          <Home width='20px' />
          {t('home')}
        </a>
        <a href='/doctors'>
          <Heart width='20px' />
          {t('doctors')}
        </a>
        
        {
          userData?.role === "admin" &&
        <a href='/dashboard'>
          <Home width='20px' />
          {t('dashboard')}
        </a>
        }
        <a href='/book-appointment'>
          <BookAppointment width='20px' />
          {t('bookAppointment')}
        </a>
        {/* <a href="/">pages <ArrowRight width="30px"/></a> */}
        <a href='/medical_history'>
          <MedicalHistory width='20px' />
          {t('medicalHistory')}
        </a>
        <a href='/contact-us'>
          <Call width='20px' />
          {t('contactUs')}
        </a>
        <a href='/feedback'>
          <Feedback width='20px' />
          {t('feedback')}
        </a>
      </div>
      <div className='menu-settings'>
        <div className="darkMode" onClick={()=>changeMode()}>
          {
            theme==="dark"?<Moon width="20"/>:<Sun width="20"/>
          }
          <p>{t('darkMode')}</p>
        </div>
        <div className="lang">
          <Lang width='20px' />
          <button
            className="lang-btn"
            onClick={() => i18n.changeLanguage(i18n.language === 'en' ? 'ar' : 'en')}
          >
            {i18n.language === 'en' ? 'عربي' : 'English'}
          </button>
        </div>
        {
          userData ?
          (
            <p className="logout-item" onClick={()=>setIsLogoutModalOpen((prev)=>!prev)}>
              <LogoutIcon width='20px' />
              {t('logout')}
            </p>
          ):
          (
            <p className="login-item" onClick={()=>nav('/login')}>
            <Login width='20px' />
            {t('login')}
            </p>
          )
        }
        <div>

        </div>
      </div>

      
      {/* logout modal in mobile */}
      <AnimatePresence>
      {
        isLogoutModalOpen &&

          <motion.div
            
            initial={{translateY: 100, opacity: 0}}
            animate={{translateY: 0, opacity: 1}}
            exit={{translateY: 100, opacity: 0}}
            transition={{duration: 0.2}}
          
          className="logout-modal-mobile">
            {
              loader?
              <BtnLoader/>:
            <button onClick={()=>Logout({openModal : setIsLogoutModalOpen , nav , setLoader})}>{t('logout')}</button>
            }
            <button onClick={()=>setIsLogoutModalOpen((prev)=>false)}>{t('no')}</button>
          </motion.div>
    }
    </AnimatePresence>
    </div>
    </>
  );
}
export default MobileNavMenu;
